<template>
  <div class="achievement-detail">
    <achiTitle title="科研成果详情" subtitle="展示成果完整信息，支持技术转化对接" />

    <!-- 核心详情内容 -->
    <div class="detail-content">
      <!-- 1. 标题与类别区（隐藏ID，类别放大醒目） -->
      <div class="header-section">
        <h1 class="achievement-name">{{ showData.projectName }}</h1>
        <div class="category-badge">
          <span>{{ showData.category || '无类别' }}</span>
        </div>
      </div>

      <!-- 2. 基础信息区（调整布局，添加图标） -->
      <div class="basic-info-section">
        <el-card shadow="hover" class="basic-card">
          <!-- 第一行：所属机构 + 项目进度 -->
          <div class="info-row">
            <div class="info-item with-icon">
              <el-icon :size="20">
                <Coordinate />
              </el-icon>
              <span class="info-label">所属机构</span>
              <span class="info-value">{{ showData.institution?.name || '未关联机构' }}</span>
            </div>
            <div class="info-item with-icon">
              <el-icon :size="20">
                <SetUp />
              </el-icon>
              <span class="info-label">项目进度</span>
              <span class="info-value">{{ showData.projectProgress || '未填写' }}</span>
            </div>
          </div>

          <!-- 第二行：成果类别（单独一行） -->
          <div class="info-row">
            <div class="info-item with-icon full-width">
              <el-icon :size="20">
                <FolderChecked />
              </el-icon>
              <span class="info-label">成果类别</span>
              <span class="info-value">{{ showData.category || '无类别' }}</span>
            </div>
          </div>

          <!-- 第三行：拟转化方式（单独一行） -->
          <div class="info-row">
            <div class="info-item with-icon full-width">
              <el-icon :size="20">
                <Tickets />
              </el-icon>
              <span class="info-label">拟转化方式</span>
              <span class="info-value">{{ showData.proposedTransformationMethod || '未填写' }}</span>
            </div>
          </div>

          <!-- 第四行：拟转化金额（单独一行） -->
          <div class="info-row">
            <div class="info-item with-icon full-width">
              <el-icon :size="20">
                <Coin />
              </el-icon>
              <span class="info-label">拟转化金额</span>
              <span class="info-value">{{ showData.proposedTransformationAmount ?
                `${showData.proposedTransformationAmount} 元` : '面议' }}</span>
            </div>
          </div>

          <!-- 第五行：知识产权状况（单独一行） -->
          <div class="info-row">
            <div class="info-item with-icon full-width">
              <el-icon :size="20">
                <Reading />
              </el-icon>
              <span class="info-label">知识产权状况</span>
              <span class="info-value">{{ showData.intellectualPropertyStatus || '未填写' }}</span>
            </div>
          </div>
        </el-card>
      </div>

      <!-- 3. 联系人与对接区（添加图标） -->
      <div class="contact-section">
        <el-card shadow="hover" class="contact-card">
          <div slot="header" class="card-header">
            <i class="el-icon-user mr-2"></i>对接信息
          </div>
          <div class="contact-content">
            <div class="contact-item with-icon">
              <el-icon :size="20">
                <User />
              </el-icon>
              <span class="contact-label">联系人：</span>
              <span class="contact-value">{{ showData.contactPerson || '未填写' }}</span>
            </div>
            <div class="contact-item with-icon">
              <el-icon :size="20">
                <ChatDotRound />
              </el-icon>
              <span class="contact-label">联系方式：</span>
              <span class="contact-value">{{ showData.contactInfo || '未填写' }}</span>
            </div>
          </div>
        </el-card>
      </div>

      <!-- 4. 成果详情区（添加图标） -->
      <div class="description-section">
        <el-card shadow="hover" class="description-card">
          <div slot="header" class="card-header">
            <i class="el-icon-document mr-2"></i>项目介绍
          </div>
          <div class="description-content">
            {{ showData.projectIntroduction || '暂无项目介绍' }}
          </div>
        </el-card>
      </div>

      <!-- 返回按钮 -->
      <div class="back-section">
        <el-button type="default" @click="$router.go(-1)" icon="el-icon-arrow-left">
          返回列表
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>

import achiTitle from '../components/achievement/achi_title.vue';
import achievementApi from '@/api/achievements.js';

export default {
  name: 'AchievementDetail',
  components: {
    achiTitle
  },
  data() {
    return {
      showData: {},
      loading: false, // 补充 loading 状态（之前遗漏）
      error: null     // 补充 error 状态（之前遗漏）
    }
  },
  props: {
    id: {
      type: [String, Number], // 支持数字/字符串 ID
      required: true,
    }
  },
  methods: {
    async loadData() {
      try {
        this.loading = true
        // 优先使用 props.id（路由配置 props: true 时），兼容 $route.params.id
        const achievementId = this.id || this.$route.params.id;
        let res = await achievementApi.getColumnById(achievementId)
        this.showData = res.data
        console.log(this.showData)
      } catch (err) {
        this.error = '数据加载失败，请刷新页面重试';
        console.error('加载数据出错:', err);
      } finally {
        this.loading = false;
      }
    }
  },
  created() {
    this.loadData()
    console.log('当前成果ID:', this.id || this.$route.params.id)
  }
};
</script>

<style scoped>
/* 全局容器 */
.achievement-detail {
  max-width: 80%;
  margin: 30px auto;
  padding: 0 20px;
  font-family: "Microsoft YaHei", sans-serif;
}

/* 详情内容区 */
.detail-content {
  background: #fff;
  border-radius: 8px;
  padding: 28px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
}

/* 标题区 - 隐藏ID，类别放大醒目 */
.header-section {
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f0f0f0;
  position: relative;
}

.achievement-name {
  font-size: 24px;
  font-weight: 600;
  color: #1f2d3d;
  margin: 0 0 16px 0;
  line-height: 1.5;
}

/* 类别徽章 - 放大、醒目 */
.category-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 18px;
  font-weight: 500;
  color: #2d8cf0;
  /* 醒目蓝色 */
  padding: 6px 12px;
  background: #e8f4ff;
  border-radius: 6px;
}

.category-badge i.el-icon-tag {
  font-size: 20px;
  color: #2d8cf0;
}

/* 基础信息区 - 调整为行布局 */
.basic-info-section {
  margin-bottom: 24px;
}

.basic-card {
  border-radius: 8px;
  padding: 20px;
}

/* 信息行布局 */
.info-row {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 16px;
  align-items: center;
}

/* 带图标的信息项 */
.info-item.with-icon {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
  border-radius: 6px;
  flex: 1;
  min-width: 280px;
  /* 最小宽度，避免太窄 */
}

/* 单独一行的信息项 - 占满宽度 */
.info-item.full-width {
  flex: 100%;
  min-width: 100%;
}

/* 信息图标 - 统一颜色和大小 */
.info-icon {
  font-size: 18px;
  color: #2d8cf0;
  /* 图标统一蓝色 */
  width: 24px;
  text-align: center;
}

.info-label {
  color: #86909c;
  font-weight: 500;
  min-width: 90px;
  /* 标签固定宽度，对齐更整齐 */
  font-size: 18px;
}

.info-value {
  color: #1f2d3d;
  font-weight: 400;
  line-height: 1.5;
  font-size: 18px;
  flex: 1;
}

/* 对接信息区 - 带图标 */
.contact-section {
  margin-bottom: 24px;
}

.contact-card {
  border-radius: 8px;
  padding: 20px;
}

.card-header {
  font-size: 24px;
  font-weight: 500;
  color: #1f2d3d;
  display: flex;
  align-items: center;
}

.card-header .mr-2 {
  margin-right: 8px;
}

.contact-content {
  padding: 15px 0;
  font-size: 18px;
}

.contact-item.with-icon {
  margin-bottom: 12px;
  margin-left: 15px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.contact-label {
  color: #86909c;
  font-weight: 500;
  min-width: 80px;
}

.contact-value {
  color: #1f2d3d;
  flex: 1;
}

/* 成果简介区 */
.description-card {
  border-radius: 8px;
  margin-bottom: 24px;
  padding: 20px;
}

.description-content {
  font-size: 15px;
  line-height: 1.8;
  color: #4e5969;
  padding: 15px 0;
  text-align: justify;
  white-space: pre-line;
  background: #f8f9fa;
  padding: 16px;
  border-radius: 6px;
}

/* 返回按钮区 */
.back-section {
  text-align: left;
  margin-top: 10px;
}

/* 响应式适配 */
@media screen and (max-width: 768px) {
  .achievement-detail {
    max-width: 100%;
    margin: 15px auto;
    padding: 0 15px;
  }

  .detail-content {
    padding: 20px 15px;
  }

  .achievement-name {
    font-size: 20px;
  }

  .category-badge {
    font-size: 16px;
    padding: 4px 10px;
  }

  .info-item.with-icon {
    min-width: 100%;
  }
}

@media screen and (max-width: 480px) {
  .achievement-name {
    font-size: 18px;
  }

  .info-label {
    min-width: 70px;
  }

  .contact-label {
    min-width: 70px;
  }
}
</style>